import { Pipe, PipeTransform } from '@angular/core';
import { IStep } from '../../../interfaces/step.interface';

@Pipe({
  name: 'stepClasses',
  standalone: true,
})
export class StepClassesPipe implements PipeTransform {
  transform(index: number, activeStepIndex: number, currentStep: IStep, nextStep: boolean = false, steps: IStep[] = []): string {
    const stepStateClass = nextStep ? '' : this.getStepStateClass(index, activeStepIndex, currentStep);
    return `${stepStateClass}`;
  }

  private getStepStateClass(index: number, activeStepIndex: number, step: IStep): string {
    let classes = '';
    if (index === activeStepIndex) classes += ' step-active';
    if (step.statusType == 'None') classes += ' step-upcoming';
    if (step.statusType == 'EnRoute') classes += ' step-en-route';
    if (step.statusType == 'Skipped') classes += ' step-skipped';
    if (step.statusType == 'Visited') classes += ' step-visited';
    if (step.statusType == 'Arrived') classes += ' step-arrived';

    return classes;
  }
}
